import { useNavigate } from "react-router-dom";

export const useViewTransitionNavigate = () => {
    const navigate = useNavigate();

    return (to, type = "forwards") => {
        if (!document.startViewTransition) {
            navigate(to);
            return;
        }

        document.startViewTransition(() => {
            document.documentElement.style.setProperty(
                "--transition-type",
                type
            );

            navigate(to);
        });
    };
};